<template>
  <AppLink to="/">
    <AppImg src="/images/logo-white.svg" alt="Logo" width="140" height="40" />
  </AppLink>
</template>